import { Component, OnInit, Input } from '@angular/core';
import { ItemGeneralListado } from '../../../helpers/components/itemClasses/itemListadoGeneral.class';

@Component({
  selector: 'timeline-negocio',
  templateUrl: './timeline.component.html'
})
export class TimelineNegocioConfiguracionComponent implements OnInit {
  @Input('negocio') negocio: ItemGeneralListado;
  @Input('codSistema') codSistema: String;
  @Input('codNegocio') codNegocio: String;

  constructor() { }

  ngOnInit() {}

}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/channel/timeline.component.ts